import React, { Component } from 'react'
import Main from './Main'
import DrawerMenu from './drawer/DrawerMenu'
import Footer from './Footer'
import { NavLink } from 'react-router-dom'
import Cookies from 'universal-cookie'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verified: true
    };
  }

  // when component mounts, first thing it does is fetch all existing data in our db
  // then we incorporate a polling logic so that we can easily see if our db has
  // changed and implement those changes into our UI
  componentDidMount() {
    this.renderRedirect();
  }

  renderRedirect = () => {
    const cookies = new Cookies();
    if (cookies.get('verified') !== 'true') {
      this.setState(
        {verified: false}
      )
    }
  }

  setCookieTrue() {
    const cookies = new Cookies();
    cookies.set('verified', 'true', { path: '/' })
    this.setState(
      {verified: true}
    )
  }

  render(){
    if (this.state.verified) {
      return(
        <div style={{height:'100%'}}>
	       <DrawerMenu />
	       <Main />
         <Footer />
        </div>
      );
    } else {
      return (
        <div style={{ height:'100vh',border:'5vw solid green', display:'flex',
          justifyContent:'center', alignItems:'center'}}>
          <div style={{
            display:'flex',flexDirection:'column',
            alignItems:'center',justifyContent:'center',
            height:'95vh',width:'95vw',backgroundColor:"#2d2f2d",
            fontFamily:'Raleway',color:'white',fontSize:'24px'}}>
            <div>Are you age 21 or older?</div>
            <nav style={{
              display: 'flex', flexDirection: 'row',
              marginTop:'10vh'}}>
              <NavLink to='/' href="#top"
              onClick={() => this.setCookieTrue()}
              style={{marginRight:'5vw', textDecoration: 'none'}}>
                <div id="yes" style={{color:'white'}}>Yes</div>
              </NavLink>
              <NavLink to='/' href="#top"
                style={{marginLeft:'5vw', textDecoration: 'none'}}>
                <div id="no" style={{color:'white'}}>No</div>
              </NavLink>
            </nav>
          </div>
        </div>
      );
    }
  }
}

export default App;
